import React from 'react'

const CreateUser = ({handleCreateUser, formData, handleChange,formErrors }) => {
    return (
        <div
            className="modal fade"
            id="exampleModal"
            tabIndex={-1}
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-lg modal-dialog modal-dialog-centered">
                <div className="modal-content radius-16 bg-base">
                    <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
                        <h1 className="modal-title fs-5" id="exampleModalLabel">
                            Create User
                        </h1>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        />
                    </div>
                    <div className="modal-body p-24">
                        <form onSubmit={handleCreateUser}>
                            <div className="row">
                                {/* First Name */}
                                <div className="col-12 col-md-6 mb-20">
                                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                        Full Name
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control radius-8"
                                        placeholder="Enter Full Name"
                                        name="fullName"
                                        value={formData.fullName}
                                        onChange={handleChange}
                                        required
                                        
                                    />
                                    {formErrors.fullName && <small className="text-danger">{formErrors.fullName}</small>}
                                </div>

                                {/* Last Name */}
                             

                                {/* Email */}
                                <div className="col-12 col-md-6 mb-20">
                                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                        Email
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control radius-8"
                                        placeholder="Enter Email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required

                                    />
                                    {formErrors.email && <small className="text-danger">{formErrors.email}</small>}
                                </div>

                                {/* Password */}
                                {/* <div className="col-12 col-md-6 mb-20">
                                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                        Password
                                    </label>
                                    <input
                                        type="password"
                                        className="form-control radius-8"
                                        placeholder="Enter Password"
                                        name="password"
                                        value={formData.password}
                                        onChange={handleChange}
                                        required

                                    />
                                    {formErrors.password && <small className="text-danger">{formErrors.password}</small>}
                                </div> */}

                                {/* Country Code */}
                                <div className="col-12 col-md-6 mb-20">
                                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                        Country Code
                                    </label>
                                    <select
                                        className="form-control radius-8"
                                        name="countryCode"
                                        value={formData.countryCode}
                                        onChange={handleChange}
                                        
                                        required
                                    >
                                        <option value="">-- Select Country Code --</option>
                                        <option value="+91">+91 - India</option>
                                        <option value="+86">+86 - China</option>
                                        <option value="+1">+1 - Canada</option>
                                        <option value="+1-US">+1 - USA</option>
                                    </select>
                                    {formErrors.countryCode && <small className="text-danger">{formErrors.countryCode}</small>}
                                </div>

                                {/* Mobile Number */}
                                <div className="col-12 col-md-6 mb-20">
                                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                        Mobile Number
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control radius-8"
                                        placeholder="Enter Mobile"
                                        name="mobile"
                                        value={formData.mobile}
                                        required

                                        onChange={handleChange}
                                              onKeyPress={(e) => {
                                                if (!/[0-9]/.test(e.key)) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            maxLength={10}
                                    />
                                    {formErrors.mobile && <small className="text-danger">{formErrors.mobile}</small>}
                                </div>

                                {/* Submit */}
                                <div className="d-flex align-items-center justify-content-start gap-3 mt-12">
                                    <button
                                        type="submit"
                                        className="btn btn-primary border border-primary-600 text-md px-48 py-12 radius-8"
                                    >
                               Send Setup Link


                                    </button>
                                </div>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateUser
